import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

import { AppSettingsService } from '../../../core/services/app-settings/app-settings.service';
import { MonitorService } from '../../../core/services/monitor/monitor.service';

export enum HeaderMode {
  Visible,
  Hidden
}

@Injectable({
  providedIn: 'root'
})
export class HeaderService {
  private headerModeSubject = new BehaviorSubject<HeaderMode>(
    HeaderMode.Visible
  );

  constructor(
    private appSettingsService: AppSettingsService,
    private monitorService: MonitorService
  ) { }

  get headerMode$(): Observable<HeaderMode> {
    return this.headerModeSubject;
  }

  showHelp(): void {
    this.monitorService.logEvent(
      { name: 'help_request' },
      { sendToAppInsight: false, sendToHeap: true }
    );

    window.open(this.appSettingsService.configuration.helpUrl, '_blank');
  }

  hideHeader(): void {
    this.headerModeSubject.next(HeaderMode.Hidden);
  }

  showHeader(): void {
    this.headerModeSubject.next(HeaderMode.Visible);
  }
}
